module.exports = __webpack_public_path__ + "static/favicon-167-987bca66f7c1ff5eb90764516cd0b5b5.png";